import { render, staticRenderFns } from "./NotificationEmailModal.vue?vue&type=template&id=485e8ce6&"
import script from "./NotificationEmailModal.vue?vue&type=script&lang=ts&"
export * from "./NotificationEmailModal.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationEmailModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports